<template>
    <div class="now" v-if="isShow" :style="styleString" />
</template>


<script>
import { deepCopy } from '@/util/deep-copy'
import { SHEET_METRICS } from '../../../sheet-state'
import { sheetAxis } from '../../../sheet-axis'
import { sheetFilters, selectedGroups } from '../../../sheet-filters'
import { columnWidth } from "./column-width"

const moment = require('@/util/MPMoment')
export default {
    data() {
        return {
            timer: undefined,
            now: moment(),

            sheetAxis,

            sheetFilters,
            columnWidth
        }
    },
    watch: {},
    computed: {
        isShow: function () {
            return selectedGroups().length > 0
        },
        selectedDate: function () {
            return moment(this.sheetAxis.selectedDate)
        },
        sheetStartedAt: function () {
            let selectedDate = this.selectedDate
            let startedAt = moment(this.sheetAxis.sheetStartedAt)
            let d = moment(selectedDate).set('hour', startedAt.hour()).set('minute', startedAt.minute())
            return d
        },
        sheetEndedAt: function () {
            let selectedDate = this.selectedDate
            let endedAt = moment(this.sheetAxis.sheetEndedAt)
            let d = moment(selectedDate).set('hour', endedAt.hour()).set('minute', endedAt.minute())
            return d
        },
        timeArray: function () {
            return this.sheetAxis.timeArray
        },
        currentTimeObject: function () {
            let now = moment(this.now)
            let timeInterval = this.sheetAxis.selectedTimeInterval
            for (let i = 0; i < this.timeArray.length; i++) {
                let time = this.timeArray[i].time
                let next = moment(time).add(timeInterval, 'minutes')
                if (time.isSameOrAfter(now) && now.isBefore(next)) { return this.timeArray[i] }
            }
            return undefined
        },
        timeInterval: function () {
            return this.sheetAxis.selectedTimeInterval
        },
        cellHeight: function () {
            return SHEET_METRICS.defaultCellHeight
        },
        originPixelPerMinutes: function () {
            return this.cellHeight / this.timeInterval
        },
        usedColumnCount: function () {
            let count = 0
            let groups = deepCopy(selectedGroups()) ?? []
            let columns = deepCopy(this.sheetFilters.columns) ?? []
            groups.forEach(g => {
                let groupID = g._id
                g.columns = columns.filter(c => c.isSelected == true && c.groupID == groupID)
                if (g.columns.length == 0) { g.columns.push({ isEmpty: true }) }
                count += g.columns.length
            })
            return count
        },
        originPixelPerColumns: function () {
            return SHEET_METRICS.defaultCellWidth
        },
        storedWidthArray: function () {
            let groups = deepCopy(selectedGroups()) ?? []
            let columns = deepCopy(this.sheetFilters.columns?.filter(c => c.isSelected == true && groups.some((g) => g._id == c.groupID))) ?? []
            return this.columnWidth.storedWidths.filter((data) => columns.some((c) => c._id == data._id))
        },
        totalCustomWidth: function () {
            return this.storedWidthArray.reduce((width, w) => width + w.width, 0)
        },
        width: function () {
            let totalDefaultWidth = (this.usedColumnCount - this.storedWidthArray.length) * this.originPixelPerColumns
            return totalDefaultWidth + this.totalCustomWidth
        },
        top: function () {
            if (this.now.isBefore(this.sheetStartedAt)) { return 0 }
            if (this.sheetEndedAt.isBefore(this.now)) { return 0 }

            if (this.currentTimeObject == undefined) {
                let diff = this.now - this.sheetStartedAt
                let minutes = diff / 1000 / 60

                return (minutes * this.originPixelPerMinutes) + 27 + 29
            }
            let diff = this.now - this.currentTimeObject.time
            let minutes = (diff / 1000 / 60) * this.originPixelPerMinutes
            let top = this.currentTimeObject.topMargin + minutes
            return top + 27 + 29
        },
        styleString: function () {
            return 'left: 50px; top: ' + this.top + 'px;' + ' width: ' + this.width + 'px;'
        }
    },
    mounted() {
        this.startTimer()
    },
    destroyed() {
        this.stopTimer()
    },
    methods: {
        // MARK: - Timer
        startTimer() {
            this.timer = setInterval(() => {
                this.now = moment()
                // }, 30000)
            }, 1000)
        },
        stopTimer() {
            clearTimeout(this.timer)
        }
    }
}
</script>